// (Copyright) Confluent, Inc.

import { css } from 'styled-components';

import { type Spacing } from '../constants/spacings';

export type Padding = Spacing | PaddingObj;

export type PaddingObj = {
  bottom?: Spacing;
  horizontal?: Spacing;
  left?: Spacing;
  right?: Spacing;
  top?: Spacing;
  vertical?: Spacing;
};

export const getPaddingCss = (padding: Padding) => {
  if (typeof padding === 'number') {
    return css`
      padding: ${padding}px;
    `;
  }

  if (typeof padding === 'object') {
    const top = padding.top ?? padding.vertical ?? 0;
    const right = padding.right ?? padding.horizontal ?? 0;
    const bottom = padding.bottom ?? padding.vertical ?? 0;
    const left = padding.left ?? padding.horizontal ?? 0;

    return css`
      padding: ${top}px ${right}px ${bottom}px ${left}px;
    `;
  }

  return css`
    padding: 0;
  `;
};

export const paddingProp =
  (defaultPadding: Padding) =>
  ({ padding }: { padding: Padding }) =>
    getPaddingCss(padding ?? defaultPadding);
